import { useOrganizationsServiceOrganizationsTeamRolesListKey } from '@organization/api/queries'
import { OrganizationsService } from '@organization/api/requests'
import { InfiniteSelect } from '@shared/components'
import { SelectProps } from 'antd'
import { useTranslation } from 'react-i18next'

export const RoleSelect = (props: SelectProps) => {
  const { t } = useTranslation()

  return (
    <InfiniteSelect
      placeholder={t('form.placeholder.select_roles')}
      apiCall={({ pageParam, pageSize, search }) =>
        OrganizationsService.organizationsTeamRolesList(
          undefined,
          undefined,
          undefined,
          pageParam,
          pageSize,
          search
        )
      }
      getOption={({ name, id }) => ({ label: name, value: id })}
      queryKey={[useOrganizationsServiceOrganizationsTeamRolesListKey]}
      mode="multiple"
      {...props}
    />
  )
}
